import { IndexGroupsVM } from "./ISearchServiceReg";

export class NameCIF {
  name: string;
}

export class PlanRoleCIF {
 planroleID: number | undefined;
}
export class AddressCIF {
  address: string;
}
export class PlanNumCIF {
  plannum: string;
}

export class PlanCertTypeCIF {
  id: number;
  certnum: string;
}
export class UnindexDateRangeCIF {
  dateranges: IndexGroupsVM[];
}

export class RoleTypeCIF {
  roleID: number | undefined;
}

export class UnindexDateRange {
  dateRangeId: number | undefined;
  dateRange: string | undefined;
  IsSelected: boolean;
}

export class CompoundNameIdxCIF {
  lastcorpName: string;
  fName: string;
}

export class RoleCIF {
  roleID: number | undefined;
}
